//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import utils from "../JS/utils"
import ajax from "../JS/ajax"
var qs = require("qs")
export default {
  name: "loginModle",
  data() {
    return {
      countdown: 60,
      autocode: '',
      phone: '',
      verifyCodeText: '获取验证码',
      setTimeout: "",
      userId: localStorage.getItem("userId"),
      bindnumber: 0,// 登录方式 0 普通登录 1 登录绑定
      wxname: "",// 微信昵称
      selected: 1,
      types: "password",
      pwd: "",
      name: "",
      sele: true,
      phoneCodeModle: false,// 图形验证码模块
      phoneCodeObject: {// 图形验证码对象
        source: "",// 来源
        img: "",// 图形
        value: "",// 图形值
        verify: false,// 是否验证
      },
      loadLogin: false,
    }
  },
  props: ['msg'],
  created() {
    var that = this;
    // 主要防止登录和支付这两个使用code冲突
    if (that.msg.code && !that.userId) {
      setTimeout(function () {
        that.wxlogin();
      }, 100);
    }
  },
  watch: {
    msg: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.bindphone) {
          // 百度事件统计
          utils.baiDuEvent("登录弹框", "开启弹框(手机号验证码登录)");
        } else if (newVal.bindphone2) {
          // 百度事件统计
          utils.baiDuEvent("登录弹框", "开启弹框(绑定手机号)");
        } else if (newVal.isShow) {
          // 百度事件统计
          utils.baiDuEvent("登录弹框", "开启弹框(微信授权登录)");
        }
        this.clearData();//初始化全局变量
      }
    }
  },
  methods: {
    //初始化全局变量
    clearData() {
      this.countdown = 60;
      this.autocode = '';
      // this.phone = '';
      this.verifyCodeText = '获取验证码';
      clearTimeout(this.setTimeout);
      this.userId = localStorage.getItem("userId");
      this.bindnumber = 0;// 登录方式 0 普通登录 1 登录绑定
      this.wxname = "";// 微信昵称
      this.selected = 1;
      this.types = "password";
      this.pwd = "";
      this.name = "";
      this.sele = true;
      this.loadLogin = false;
    },
    outinput() {
      // window.scroll(0, 0);
      // document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    logintype(source) {
      var that = this;
      if (!that.sele) {
        that.$toast({ msg: "请同意勾选“已阅读并同意”相关协议再登录哦" });
        return;
      }
      var bindnumber = that.bindnumber;// 登录方式
      if (bindnumber == 0) {
        that.loginphone(source);
      } else if (bindnumber == 1) {
        that.bind(source);
      }
    },
    loginphone(source) {
      var that = this;
      if (that.phone == "") {
        that.$toast({ msg: "请输入手机号码" });
        return;
      } else if (that.phone.length < 11) {
        that.$toast({ msg: "手机号码不正确" });
        return;
      } else if (!that.autocode) {
        that.$toast({ msg: "请输入短信验证码" });
        return;
      } else {
        var url = "/daoway/rest/users/login_phone";
        var datas = {
          phone: that.phone,
          code: that.autocode,
          channel: utils.channel,
          inviter: utils.inviter,
          userId: that.userId
        };
        var bdVid = "";
        if (localStorage.getItem('bd_vid')) {
          bdVid = localStorage.getItem('bd_vid');
        }
        if (bdVid != undefined && bdVid != "") {
          datas["bdVid"] = bdVid;
        }
        if (source == "bind") {
          // 百度事件统计
          utils.baiDuEvent("登录弹框", "绑定手机号");
        } else {
          // 百度事件统计
          utils.baiDuEvent("登录弹框", "手机号验证码登录");
        }
        that.loadLogin = true;
        ajax.post(url, qs.stringify(datas), {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }).then((res) => {
          var result = res.data;
          if (result.status === "ok") {
            var data = result.data;
            if (source == "bind") {
              that.$toast({ msg: "绑定成功", type: "success" });
              // 百度事件统计
              utils.baiDuEvent("登录弹框", "绑定手机号-绑定成功");
            } else {
              that.$toast({ msg: "登录成功", type: "success" });
              // 百度事件统计
              utils.baiDuEvent("登录弹框", "手机号验证码登录-登录成功");
            }
            localStorage.setItem("nick", data.nick);
            localStorage.setItem("pwd", data.password);
            if (data.phone != undefined && data.phone != null) {
              localStorage.setItem("phone", data.phone);
            } else {
              localStorage.setItem("phone", "");
            }
            localStorage.setItem("userId", data.userId);
            var token = utils.getCookie("token") || data.token;
            localStorage.setItem("token", token);
            utils.setCookie("token", token);
            that.userId = data.userId;
            that.getdwvip(data.userId);
            that.msg.isShow = false;
            that.msg.bindphone = false;
            that.msg.bindphone2 = false;
            that.$parent.fatherMethod(data.userId);
            that.$router.push({
              path: that.msg.page,
            });
          } else {
            that.$dialog({
              title: "还有点问题",
              content: result.msg,
              confirm: function () { },
            });
            if (source == "bind") {
              // 百度事件统计
              utils.baiDuEvent("登录弹框", "绑定手机号-绑定失败(" + result.msg + ")");
            } else {
              // 百度事件统计
              utils.baiDuEvent("登录弹框", "手机号验证码登录-登录失败(" + result.msg + ")");
            }
          }
          that.loadLogin = false;
        });
      }
    },
    tabsele() {
      this.sele = !this.sele;
    },
    selectedTab(obj) {
      this.selected = obj;
    },
    changetype() {
      if (this.types == "password") {
        this.types = "text";
      } else {
        this.types == "password";
      }
    },
    bind(source) {
      var that = this;
      if (that.phone == "") {
        that.$toast({ msg: "请输入手机号码" });
        return;
      } else if (that.phone.length < 11) {
        that.$toast({ msg: "手机号码不正确" });
        return;
      } else if (!that.autocode) {
        that.$toast({ msg: "请输入短信验证码" });
        return;
      } else {
        var url = "/daoway/rest/verify/validate?phone=" + that.phone + "&code=" + that.autocode + "&channel=" + utils.channel;
        if (that.userId) {
          url += '&userId=' + that.userId
        }
        // 百度事件统计
        utils.baiDuEvent("登录弹框", "手机号验证码登录(登录绑定)");
        that.loadLogin = true;
        ajax.get(url, {
          headers: {
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }).then((res) => {
          var result = res.data;
          if (result.status === "ok") {
            var data = result.data;
            if (source == "bind") {
              that.$toast({ msg: "绑定成功", type: "success" });
              // 百度事件统计
              utils.baiDuEvent("登录弹框", "手机号验证码登录(登录绑定)-绑定成功");
            } else {
              that.$toast({ msg: "登录成功", type: "success" });
              // 百度事件统计
              utils.baiDuEvent("登录弹框", "手机号验证码登录(登录绑定)-登录成功");
            }
            localStorage.setItem("nick", data.nick);
            localStorage.setItem("pwd", data.encPwd);
            if (data.phone != undefined && data.phone != null) {
              localStorage.setItem("phone", data.phone);
            } else {
              localStorage.setItem("phone", that.phone);// 绑定成功且没有返回用户信息时填充手机号
            }
            localStorage.setItem("userId", data.userId);
            that.userId = data.userId;
            var token = utils.getCookie("token") || data.token;
            utils.setCookie("token", token);
            localStorage.setItem("token", token);
            that.$parent.fatherMethod(data.userId);
            that.msg.isShow = false;
            that.msg.bindphone = false;
            that.msg.bindphone2 = false;
            that.$router.push({
              path: that.msg.page,
            });
          } else {
            that.$dialog({
              title: "还有点问题",
              content: result.msg,
              confirm: function () { },
            });
            if (source == "bind") {
              // 百度事件统计
              utils.baiDuEvent("登录弹框", "手机号验证码登录(登录绑定)-绑定失败(" + result.msg + ")");
            } else {
              // 百度事件统计
              utils.baiDuEvent("登录弹框", "手机号验证码登录(登录绑定)-登录失败(" + result.msg + ")");
            }
          }
          that.loadLogin = false;
        });
      }
    },
    loginname() {
      var that = this;
      var url = "/daoway/rest/users/login";
      if (!that.sele) {
        that.$toast({ msg: "请同意勾选“已阅读并同意”相关协议再登录哦" });
        return;
      }
      var datas = {
        user_name: that.name,
        password: that.pwd,
        channel: utils.channel,
        inviter: that.inviter,
      };
      var bdVid = "";
      if (localStorage.getItem('bd_vid')) {
        bdVid = localStorage.getItem('bd_vid');
      }
      if (bdVid != undefined && bdVid != "") {
        datas["bdVid"] = bdVid;
      }
      // 百度事件统计
      utils.baiDuEvent("登录弹框", "账号密码登录");
      that.loadLogin = true;
      ajax.post(url, qs.stringify(datas), {
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      }).then((res) => {
        var result = res.data;
        if (result.status === "ok") {
          var data = result.data;
          that.$toast({ msg: "登录成功", type: "success" });
          // 百度事件统计
          utils.baiDuEvent("登录弹框", "账号密码登录-登录成功");
          localStorage.setItem("nick", data.nick);
          localStorage.setItem("pwd", data.encPwd);
          if (data.phone != undefined && data.phone != null) {
            localStorage.setItem("phone", data.phone);
          } else {
            localStorage.setItem("phone", "");
          }
          localStorage.setItem("userId", data.userId);
          var token = utils.getCookie("token") || data.token;
          localStorage.setItem("token", token);
          utils.setCookie("token", token);
          that.userId = data.userId;
          that.getdwvip(data.userId);
          that.msg.isShow = false;
          that.msg.bindphone = false;
          that.msg.bindphone2 = false;
          that.$parent.fatherMethod(data.userId);
          that.$router.push({
            path: that.msg.page,
          });
        } else {
          that.$dialog({
            title: "还有点问题",
            content: result.msg,
            confirm: function () { },
          });
          // 百度事件统计
          utils.baiDuEvent("登录弹框", "账号密码登录-登录失败(" + result.msg + ")");
        }
        that.loadLogin = false;
      });
    },
    wxlogin() {
      var that = this;
      // 获取已经使用过的支付code
      var paycodeUsedArray = [];
      try {
        var paycodeUsedValue = localStorage.getItem('paycodeUsedArray');
        if (paycodeUsedValue) {
          paycodeUsedArray = JSON.parse(paycodeUsedValue);
        }
      } catch (e) {
        //TODO handle the exception
      }
      var usedStatus = false;//是否使用过
      for (var i = 0; i < paycodeUsedArray.length; i++) {
        if (paycodeUsedArray[i] == that.msg.code) {
          usedStatus = true;
        }
      }
      // code已经被使用过
      if (usedStatus) {
        return;
      }
      paycodeUsedArray.push(that.msg.code);
      localStorage.setItem("paycodeUsedArray", JSON.stringify(paycodeUsedArray));
      // 存储已经使用过的支付code
      var url = "/daoway/rest/users/login_webwxgrant?oauthCode=" + that.msg.code + "&channel=" + utils.channel + "&inviter=" + utils.inviter;
      var bdVid = "";
      if (localStorage.getItem('bd_vid')) {
        bdVid = localStorage.getItem('bd_vid');
      }
      if (bdVid != undefined && bdVid != "") {
        url += "&bdVid=" + bdVid;
      }
      that.loadLogin = true;
      ajax.get(url, {
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      }).then((res) => {
        var result = res.data;
        if (result.status === "ok") {
          var data = result.data;
          that.wxname = data.user_name;
          that.userId = data.userId;
          that.$toast({ msg: "登录成功", type: "success" });
          // 百度事件统计
          utils.baiDuEvent("登录弹框", "微信授权登录-登录成功");
          localStorage.setItem("nick", data.nick);
          localStorage.setItem("pwd", data.password);
          if (data.phone != undefined && data.phone != null) {
            localStorage.setItem("phone", data.phone);
          } else {
            localStorage.setItem("phone", "");
          }
          localStorage.setItem("userId", data.userId);
          that.msg.isShow = false;
          that.msg.bindphone = false;
          that.msg.bindphone2 = false;
          that.$parent.fatherMethod(data.userId);
          that.getdwvip(data.userId);
          // 没绑定手机号时绑定手机号
          if (!data.phoneCertified) {
            that.msg.bindphone2 = true;
          } else {
            // 百度事件统计
            utils.baiDuEvent("登录弹框", "微信授权登录-登录成功(已绑定手机号)");
          }
        } else {
          // 百度事件统计
          utils.baiDuEvent("登录弹框", "微信授权登录-登录失败(" + result.msg + ")");
        }
        that.loadLogin = false;
      });
    },
    settime() {
      var that = this;
      var countdown = that.countdown - 1;
      if (countdown > 0) {
        that.verifyCodeText = "重新发送(" + countdown + ")";
        that.countdown = countdown;
        that.setTimeout = window.setTimeout(function () {
          that.settime();
        }, 1000);
      } else {
        that.verifyCodeText = "获取验证码";
        that.verifyCodeDisabled = false;
        that.countdown = 60;
      }
    },
    getyzm(source) {
      var that = this;
      var phone = that.phone;
      if (that.verifyCodeText == '获取验证码') {
        if (phone == "") {
          that.$toast({ msg: "请输入手机号码" });
          return;
        } else if (phone.length < 11) {
          that.$toast({ msg: "手机号码不正确" });
          return;
        } else {

          // 手机号每日获取验证码次数
          // let have_get_num = 0;// 获取次数
          // let timeId = utils.dateFormat(new Date(), "yyyyMMdd");
          // let phoneStorage = localStorage.getItem("phoneGetNum_" + phone + "_" + timeId);
          // if (phoneStorage) {
          //   have_get_num = Number(phoneStorage);
          // }
          let phoneCodeObject = that.phoneCodeObject;// 图形验证码对象
          /*
         if (have_get_num > 0 && !phoneCodeObject.verify) {
           phoneCodeObject.source = source ? source : "",// 来源
             phoneCodeObject.img = "https://www.daoway.cn/daoway/rest/kaptcha/code.jpg?phone=" + phone;
           phoneCodeObject.value = "";
           that.phoneCodeObject = phoneCodeObject;
           that.phoneCodeModle = true;// 图形验证码模块
           return;
         }
           */
          var url = "/daoway/rest/verify/obtain?phone=" + phone + "&voice=false" + "&channel=" + utils.channel;
          if (that.userId) {
            url += '&userId=' + that.userId
          }
          if (phoneCodeObject.verify) {
            let verify_code = phoneCodeObject.value;
            if (verify_code) {
              url += '&verify_code=' + verify_code
            }else{
              that.$toast({ msg: "请输入图形验证码" });
              return
            }
            phoneCodeObject.verify = false;
          }

          if (source == "bind") {
            // 百度事件统计
            utils.baiDuEvent("登录弹框", "获取验证码(绑定手机号)");
          } else {
            // 百度事件统计
            utils.baiDuEvent("登录弹框", "获取验证码(手机号验证码登录)");
          }
          // that.loadLogin = true;
          ajax.get(url, {
            headers: {
              "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
            },
          }).then((res) => {
            var result = res.data;
            phoneCodeObject.value = "";
            if (result.status === "ok") {
              phoneCodeObject.verify = false;
              // 设置手机号每日获取验证码次数
              // have_get_num++;
              // localStorage.setItem("phoneGetNum_" + phone + "_" + timeId, have_get_num);
              // that.verifyCodeDisabled = true;
              that.$toast({ msg: "已发送" });
              if (source == "bind") {
                // 百度事件统计
                utils.baiDuEvent("登录弹框", "获取验证码(绑定手机号)-获取成功");
              } else {
                // 百度事件统计
                utils.baiDuEvent("登录弹框", "获取验证码(手机号验证码登录)-获取成功");
              }
              that.settime();
              if (result.data) {
                if (!result.data.login_phone) {
                  that.bindnumber = 1;
                }
              }
            } else {
              if (result.code == 403) {
                phoneCodeObject.img = "https://www.daoway.cn/daoway/rest/kaptcha/code.jpg?phone=" + phone;
                that.phoneCodeObject = phoneCodeObject;
                that.phoneCodeModle = true;// 图形验证码模块
              } else {
                that.$dialog({
                  title: "还有点问题",
                  content: result.msg,
                  confirm: function () { },
                });
              }
              if (source == "bind") {
                // 百度事件统计
                utils.baiDuEvent("登录弹框", "获取验证码(绑定手机号)-获取失败(" + result.msg + ")");
              } else {
                // 百度事件统计
                utils.baiDuEvent("登录弹框", "获取验证码(手机号验证码登录)-获取失败(" + result.msg + ")");
              }
            }
            // 设置图形验证码验证状态初始化
            // phoneCodeObject.verify = false;
            // that.phoneCodeObject = phoneCodeObject;
            // that.loadLogin = false;
          }, function (res) {
            that.$dialog({
              title: "还有点问题",
              content: '您的请求过于频繁(code=0)，请稍后重试',
              confirm: function () { },
            });
            that.loadLogin = false;
          });
        }
      }
    },
    getcode() {
      // 微信登录前的页面网址
      // localStorage.setItem("wxLoginUrl", this.msg.page);
      // 百度事件统计
      utils.baiDuEvent("登录弹框", "微信授权登录");
      this.msg.isShow = false;
      utils.weixinlogin(this.msg.page);
    },
    close(source) {
      this.msg.isShow = false;
      this.msg.bindphone = false;
      this.msg.bindphone2 = false;
      if (source == "1") {
        // 百度事件统计
        utils.baiDuEvent("登录弹框", "关闭弹框(手机号验证码登录)");
      } else if (source == "2") {
        // 百度事件统计
        utils.baiDuEvent("登录弹框", "关闭弹框(绑定手机号)");
      } else if (source == "3") {
        // 百度事件统计
        utils.baiDuEvent("登录弹框", "关闭弹框(微信授权登录)");
      }
    },
    refreshImg() {
      var that = this;
      let phoneCodeObject = that.phoneCodeObject;// 图形验证码对象
      phoneCodeObject.img = "";
      that.phoneCodeObject = phoneCodeObject;
      setTimeout(function () {
        var phone = that.phone;
        phoneCodeObject.img = "https://www.daoway.cn/daoway/rest/kaptcha/code.jpg?phone=" + phone;
        that.phoneCodeObject = phoneCodeObject;
      }, 100);
    },
    closeModle() {
      this.phoneCodeModle = false;// 图形验证码模块
    },
    phoneCodeVerify() {
      var that = this;
      var phone = that.phone;
      let phoneCodeObject = that.phoneCodeObject;// 图形验证码对象
      let value = phoneCodeObject.value;
      if (!value) {
        that.$toast({ msg: "请输入图形验证码" });
        return;
      }
      phoneCodeObject.verify = true;
      that.phoneCodeObject = phoneCodeObject;
      that.phoneCodeModle = false;// 图形验证码模块
      that.getyzm(phoneCodeObject.source);// 获取验证码
      // var url = "/daoway/rest/verify/pure_obtain?phone=" + phone + "&verify_code=" + value;
      // ajax.get(url, {
      //   headers: {
      //     "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
      //   },
      // }).then((res) => {
      //   var result = res.data;
      //   if (result.status === "ok") {
      //     let phoneCodeObject = that.phoneCodeObject;// 图形验证码对象
      //     phoneCodeObject.verify = true;
      //     that.phoneCodeObject = phoneCodeObject;
      //     that.phoneCodeModle = false;// 图形验证码模块
      //     that.getyzm(phoneCodeObject.source);// 获取验证码
      //   } else {
      //     that.$dialog({
      //       title: "还有点问题",
      //       content: result.msg,
      //       confirm: function () { },
      //     });
      //   }
      // }).catch((error) => {
      //   that.$dialog({
      //     title: "还有点问题",
      //     content: "网络出现问题，请稍后再试",
      //     confirm: function () { },
      //   });
      // });
    },
    getdwvip(userId) {
      var that = this;
      var url = "/daoway/rest/vip/" + userId + "/my_vip?channel=" + utils.channel;
      ajax.get(url, {
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      }).then((res) => {
        var result = res.data;
        if (result.status === "ok") {
          var data = result.data;
          var dwVip = data.dwVip;
          if (dwVip) {
            localStorage.setItem("dwVip", dwVip);
          }
        }
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/loginModle.vue